import React from "react";
import { FooterSetteings } from "./components/footerSetteings/FooterSetteings";

import parse from "html-react-parser";

import "./Footer.scss";
import { useTypeSelector } from "../../../hooks/useTypeSelector";
import { BananersEnum } from "../../../common/types/Banners/BannersList";
import { FooterBetzula } from "./components/footerBetzula/FooterBetzula";
import { Link } from "react-router-dom";
import { FooterLink } from "./components/footerlinks/FooterLink";
import mockLisence from "accets/images/png/mocklisence/photo_2024-11-07 01.04.40.jpeg";
import topBannerNew from "./mockImages/topBannerNew.png";

const Footer = () => {
  const { content } =
    useTypeSelector((data) => data?.settingsReducer?.content?.mobileFooter) ||
    [];
  const FooterTopBaner = useTypeSelector((data) =>
    data.accountInfoReducer.banners.filter(
      (item) => item.type === BananersEnum.FooterTopBaner
    )
  );
  const FooterCenterBaner = useTypeSelector((data) =>
    data.accountInfoReducer.banners.filter(
      (item) => item.type === BananersEnum.FooterCenterBaner
    )
  );
  const FooterBottomBaner = useTypeSelector((data) =>
    data.accountInfoReducer.banners.filter(
      (item) => item.type === BananersEnum.FooterBottomBaner
    )
  );

  const FooterPaymentBanners = useTypeSelector((data) =>
    data.accountInfoReducer.banners.filter(
      (item) => item.type === BananersEnum.FooterPaymentBanners
    )
  );
  const mainText =
    useTypeSelector(
      (data) =>
        data?.settingsReducer?.content?.skinStyles.filter(
          (item) => item.key === "title-casino"
        )[0]?.value
    ) || null;
  let campaignId = 0;
  if (Comm100API && Comm100API.get) {
    const campaignIds = Comm100API.get("livechat.campaignIds");
    campaignId = campaignIds[0];
  }
  const handleOpenChat = () => {
    Comm100API?.do("livechat.button.click", campaignId);
  };
  return (
    <div className="layout-footer-holder-bc">
      <div className="footerWrapper">
        <div className="footerContainerWrapper">
          <div className="footerContainer">
            <div className="footerHeader">
              <div className="footerTopButtonGroup">
                <button
                  className="button outlined small supportButton "
                  type="button"
                  onClick={() => handleOpenChat()}
                >
                  <span className="ellipsis">DESTEK İLE İLETİŞİME GEÇİN</span>
                </button>
              </div>
              <div className="footerInnerLeftCol">
                <ul className="footerSocialLinks">
                  <li className="footerSocialLink">
                    <Link to="#" target="_blank" className="" rel="noreferrer">
                      <i className="bc-i-youtube" />
                    </Link>
                  </li>
                  <li className="footerSocialLink">
                    <Link to="#" target="_blank" className="" rel="noreferrer">
                      <i className="bc-i-twitter" />
                    </Link>
                  </li>
                  <li className="footerSocialLink">
                    <Link to="#" target="_blank" className="" rel="noreferrer">
                      <i className="bc-i-telegram" />
                    </Link>
                  </li>
                  <li className="footerSocialLink">
                    <Link to="#" target="_blank" className="" rel="noreferrer">
                      <i className="bc-i-instagram" />
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footerInfoColumn">
                <div className="selectHolder big languageDropdown  filled">
                  <div className="selectContainer selectOption ">
                    <div className="selectIconBlock">
                      <i className="bc-i-small-arrow-down" />
                    </div>
                    <div className="selectImitation">
                      <div className="flagImgSelectBlock">
                        <div className="selectIconBc flagImg turkey" />
                      </div>
                      <span className="selectItemTitle">Türkçe</span>
                    </div>
                  </div>
                  <select className="selectMobile">
                    <option value="eng">English</option>
                    <option value="tur">Türkçe</option>
                  </select>
                </div>
              </div>
            </div>
            <FooterLink />
            <div className="footerSliderGroup">
              <div className="footerSlider">
                <h4 className="footerSliderTitle">
                  Regulations &amp; Partners
                </h4>
                <div className="footerSliderGroup">
                  <div className="footerSliderSingleElWrapper">
                    <div className="footerSliderSingleEl">
                      <div className="ftr-copy-rights-bc">
                        <p>
                          <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            to="betkorner.com"
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            betkorner.com
                          </Link>{" "}
                          Johan Van Walbeeckplein 24, Curacao adresinde kayıtlı,
                          8048/JAZ2020-032 oyun lisansı bulunan ve oyun
                          yazılımını işletmek için tüm haklara sahip olan Seguri
                          N.V., sicil numarası 153142 olan tarafından
                          işletilmektedir.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="footerSliderSingleElWrapper">
                    <div className="footerSliderSingleEl">
                      <Link
                        to="#"
                        target="_blank"
                        className="footerSliderImage"
                        rel="noreferrer"
                      >
                        <img loading="lazy" src={topBannerNew} alt="" />
                      </Link>
                      {/* <Link className="footerSliderImage" to="#">
                        <img
                          loading="lazy"
                          src="https://cmsbetconstruct.com/content/images/345ea2e23ad58c2dc5c968d542fea7d9_1063_media.png"
                          alt=""
                        />
                      </Link> */}
                    </div>
                  </div>
                  <div className="footerSliderSingleElWrapper">
                    <div className="footerSliderSingleEl">
                      <Link
                        to="http://cert-gcb-betkorner.com/"
                        target="_blank"
                        className="footerSliderImage"
                        rel="noreferrer"
                      >
                        <img loading="lazy" src={mockLisence} alt="" />
                      </Link>
                    </div>
                  </div>
                  <FooterBetzula />
                </div>
              </div>
              <div className="footerSlider">
                <h4 className="footerSliderTitle">Payments</h4>
                <div
                  className="horizontalSliderWrapper"
                  data-scroll-lock-scrollable=""
                >
                  <div className="horizontalSliderRow ">
                    {FooterPaymentBanners?.map((banner) => (
                      <Link
                        key={banner.id}
                        className="horizontalSliderElem"
                        to={{
                          search: "?profile=open&account=balance&page=deposit",
                        }}
                        {...(banner.link_type === "external" && {
                          target: "_blank",
                          rel: "noreferrer",
                        })}
                      >
                        <img
                          className="horizontalSliderImg"
                          src={
                            banner.desktop_image?.cloudflare ||
                            banner.desktop_image?.s3 ||
                            banner.desktop_image?.local
                          }
                          alt={banner.title}
                          loading="lazy"
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="footerCopyrightBlock">
              <div className="footerWarning">
                <span className="footerWarningAge">18+</span>
              </div>
              <p className="footerCopyrights">2014 - {new Date().getFullYear()} Betkorner</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Footer };
